import React, { Component } from 'react'
import t from '../service/translate.service'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'

const LanguagePicker = observer(
  class LanguagePicker extends Component {
    constructor (props) {
      super(props)
      this.state = {
        defVal: t.locale,
        languages: ['en', 'de']
      }

      this.selectLang = (
        <div>
          {this.state.languages.map((language, index) => {
            return (
              <Link
                key={language}
                className={t.locale === language ? 'active' : ''}
                onClick={e => this.handleSelectClick(language)}
              >
                {language.toUpperCase()}
              </Link>
            )
          })}
        </div>
      )
    }

    componentDidMount() {
      document.documentElement.setAttribute('lang', this.state.defVal)
    }

    componentDidUpdate(_, prevState) {
      if (prevState.defVal !== this.state.defVal) {
        document.documentElement.setAttribute('lang', this.state.defVal)
      }
    }

    handleSelectClick = (language) => {
      t.setLocale(language)
      this.setState({ defVal: language }) 
    }

    render () {
      return <div className='translateWrapper'>{this.selectLang}</div>
    }
  }
)

export default LanguagePicker
